import { RequestStatus } from 'features/request/requestSlice';
import type { ValidationMessage } from 'gql/graphql';

import { createSlice } from '@reduxjs/toolkit';

export interface IErrorHandlingRequestState {
    data?: any;
    result?: boolean;
    message?: string | null;
    validation?: ValidationMessage[] | null;
    buttonText?: string | null;
    hideValidation?: boolean | null;
    hasValidation?: boolean;
}

export interface IErrorHandling {
    requestData: IErrorHandlingRequestState | null;
    requestStatus: RequestStatus;
    requestError: { message: string }[] | null;
    title: string;
    requestId: string;
}

const initialState: IErrorHandling = {
    title: '',
    requestData: null,
    requestError: null,
    requestStatus: RequestStatus.FETCHING,
    requestId: '',
};

export const errorHandlingSlice = createSlice({
    name: 'errorHandling',
    initialState,
    reducers: {
        setRequestError: (state, action) => {
            state.title = action.payload.title;
            state.requestData = action.payload.data;
            state.requestError = action.payload.error;
            state.requestStatus = action.payload.status;
            state.requestId = action.payload.id;
        },
        removeRequestError: (state) => {
            state.title = '';
            state.requestData = null;
            state.requestError = null;
            state.requestStatus = RequestStatus.FETCHING;
            state.requestId = '';
        },
    },
});

export const { setRequestError, removeRequestError } = errorHandlingSlice.actions;
export const errorHandlingSliceSelectors = {
    getErrorHandlingState: (state: IErrorHandling) => state,
};
